import { requestAnimationFrame } from "GesagtGetan.Basic/Resources/Private/Assets/Helper";

window.requestAnimationFrame = requestAnimationFrame;

let windowHeight = window.innerHeight;
let isScroll = false;
let latestScroll = 0;
let blur = null;
let text = null;

function setElements() {
    let header = document.querySelector(".news-entry-header");
    if (header) {
        blur = header.querySelector(".fixed-background");
        text = header.querySelector(".news-entry-headline");
    }
}

function updateWindowHeight() {
    windowHeight = window.innerHeight;
}

function initBlur() {
    setElements();

    if (blur && text) {
        window.addEventListener(
            "scroll",
            function() {
                latestScroll = window.scrollY;
                checkScroll();
            },
            false
        );

        window.addEventListener("resize", updateWindowHeight, false);
    }
}

function checkScroll() {
    if (!isScroll) {
        window.requestAnimationFrame(update);
    }
    isScroll = true;
}

function update() {
    let currentScroll = latestScroll;
    isScroll = false;
    let textScroll = currentScroll / 4;
    let blurScroll = currentScroll * 6;
    if (text) {
        text.style.transform = "translate3d(0," + textScroll + "px,0)";
    }
    if (blur) {
        let filter = (blurScroll / windowHeight).toFixed(1);
        filter = filter <= 0 ? 0 : filter;
        blur.style.filter = "blur(" + filter + "px)";
    }
}

_gg.onReady.NewsEntry = initBlur;

export { initBlur };
